module.exports = __webpack_public_path__ + "img/1.e2f04cee.jpg";